module.exports = __webpack_public_path__ + "static/media/octes8h_4.6ce26ddc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/octes/octes8h_4.svg
// module id = 749
// module chunks = 0